let App;

function setApp(app) {
  App = app;
}

function getApp() {
  return App;
}

function isWx() {
  return (/(micromessenger|webbrowser)/i.test(navigator.userAgent));
}

export {
  setApp,
  getApp,
  isWx,
};
